// extracted by mini-css-extract-plugin
export var actions = "_r-0";
export var actionsContainer = "_r-6";
export var border = "_r-1";
export var childFullHeight = "_r-d";
export var collapse = "_r-2";
export var content = "_r-8";
export var contentChild = "_r-c";
export var fullscreen = "_r-a";
export var headerContainer = "_r-3";
export var headerRow = "_r-5";
export var hidePadding = "_r-9";
export var noScrollX = "_r-e";
export var noScrollY = "_r-f";
export var optOutTopPadding = "_r-b";
export var pagePadding = "_r-7";
export var profile = "_r-g";
export var profileContainer = "_r-h";
export var profileImage = "_r-i";
export var profileMain = "_r-j";
export var profileSubtitle = "_r-l";
export var profileTitle = "_r-k";
export var tabsWrapper = "_r-4";
export var title = "_r-m";